<template>
    <div data-nosnippet v-if="newListingCards && newListingCards.length">
        <div class="f4">New Listings in {{ placeName }}</div>
        <div class="static-gs gs-sm-2 relative-spacing">
            <mvtCardProperty v-for="(newListing,index) in newListingCards" :key="newListing.propertyId" :data="newListing"/>
        </div>
        <ul v-if="newListingLinks && newListingLinks.length">
            <li v-for="listing in newListingLinks">
                <a class="link" :href="listing.dppUrl">{{listing.geo.formatAddress}}</a>
            </li>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import mvtCardProperty from '@/common/components/mvtcardproperty/mvt-cardproperty.vue';

export default {
    name: 'guideArticleListingsSeo',
    components: {
      mvtCardProperty,
    },
    computed: {
        ...mapGetters('guide', ['guide']),
        placeName() {
            var geo = this.guide.geo;
            return geo.neighborhood || geo.city || geo.stateFullName;
        },
        newListingCards() {
            let newListings = this.guide.newListings;
            return newListings.length < 3 ? newListings : newListings.slice(0, 2);
        },
        newListingLinks() {
            let newListings = this.guide.newListings;
            return newListings.length < 6 ? newListings.slice(2) : newListings.slice(2, 5);
        }
    }
};
</script>
